import { Providers } from './app/providers';
import { Router } from './app/router';
import { ErrorBoundary } from './app/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <Providers>
        <Router />
      </Providers>
    </ErrorBoundary>
  );
}

export default App;

